export const fontOptions = [
  { label: 'Inter', value: 'inter' as const },
  { label: 'Playfair Display', value: 'playfair_display' as const },
  { label: 'Poppins', value: 'poppins' as const },
  { label: 'Open Sans', value: 'open_sans' as const },
  { label: 'Lora', value: 'lora' as const },
  { label: 'Montserrat', value: 'montserrat' as const },
  { label: 'Oswald', value: 'oswald' as const },
  { label: 'JetBrains Mono', value: 'jetbrains_mono' as const },
  { label: 'Bricolage Grotesque', value: 'bricolage_grotesque' as const },
  { label: 'Manrope', value: 'manrope' as const },
  { label: 'DM Sans', value: 'dm_sans' as const },
  { label: 'Gilda Display', value: 'gilda_display' as const },
  { label: 'Sora', value: 'sora' as const },
  { label: 'Literata', value: 'literata' as const },
  { label: 'Alice', value: 'alice' as const },
  { label: 'Comfortaa', value: 'comfortaa' as const },
];

export const components = {
  ctaButtons: [
    { label: 'Animated Arrow', value: 'animatedArrow' as const },
    { label: 'Animated Shimmer', value: 'animatedShimmer' as const },
    { label: 'Animated Pulse', value: 'animatedPulse' as const },
    { label: 'Fill bottom up', value: 'animatedFill' as const },
    { label: '3d button', value: 'animatedDepth' as const },
    { label: 'Animated Underline', value: 'animatedUnderline' as const },
  ],
};

export default {
  fontOptions,
  components,
};

/** Limits for files visitors attach to a single form submission. */
export const formFiles = {
  maxFiles: 5,
  maxTotalBytes: 25 * 1024 * 1024,
};

/** "PDF", ".pdf", " pdf " → "pdf" */
export const normalizeFileExtension = (extension: string) =>
  extension.trim().replace(/^\.+/, '').toLowerCase();

export const getFileExtension = (filename: string) => {
  const dot = filename.lastIndexOf('.');
  return dot === -1 ? '' : normalizeFileExtension(filename.slice(dot + 1));
};
